
import moment from "moment";
import React, { useState } from "react";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import Button from "../../../../components/Button";
import InputField from "../../../../components/InputField";
import { updateLeaveInfo } from "../../../../core/services/api";
import "./BlockCalendar.scss";

export default function BlockCalendar({ show, onClose, displayToast }: any) {
  const [obj, updateObj] = useState<any>({
    startDate: "",
    startTime: "",
    endDate: "",
    endTime: ""
  });
  const userDetail = useSelector((state: any) => state.user?.userDetail)
  console.log(userDetail, "user Detail");
  const history = useHistory()
  // const [displayToast, toggleDisplayToast] = useState<any>(false)


  const handleClick = () => {
    let query = `consultantId=${userDetail?.id}&centerId=${userDetail?.currentCenter?.centerId}`
    let start = `${moment(obj?.startDate).format("YYYY-MM-DD")}T${moment(obj?.startTime, "HH:mm").format("HH:mm:ss")}Z`;
    let end = `${moment(obj?.endDate).format("YYYY-MM-DD")}T${moment(obj?.endTime, "HH:mm").format("HH:mm:ss")}Z`;
    let body: any = { start, end, reason: obj?.reason };
    updateLeaveInfo(query, body).then((res) => {
      updateObj(res)
      displayToast({ text: "Successfully blocked the calendar", type: "success" })
    }).catch((err: any) => {
      updateObj(err?.response?.data?.message)
      displayToast({ text: err?.response?.data?.message, type: "error" })
    })
  }
  function isDateBeforeFrom(date1: string | number | Date, date2: string | number | Date) {

    const parsedDate1 = new Date(date1);
    const parsedDate2 = new Date(date2);
    return parsedDate1.getTime() > parsedDate2.getTime();
  }
  const isDateBeforeToday = (selectedDate: string | number | Date) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set current time to the beginning of the day
    const selected = new Date(selectedDate);
    selected.setHours(0, 0, 0, 0); // Set selected time to the beginning of the day

    return selected < today;
  };
  return (
    <div className="block-calendar-wrapper m-5">
      <Modal size="lg" show={show} onHide={onClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Row>
              <Col>
                <div style={{ fontWeight: 600, fontSize: "15px" }}>Block Calendar</div>
              </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex">

            <div className="col-md-6 col-lg-6 input-wrapper">
              <div className="label-text" style={{ fontWeight: 600, fontSize: "15px" }}>
                Start Date
              </div>
              <InputField
                className="col-md-8 time-picker"
                placeholder="Start Date"
                value={obj?.startDate}
                calendar={true}
                handleChange={(e) => {
                  if (isDateBeforeToday(e.target?.value)) {
                    displayToast({
                      text: "Selected date cannot be before today",
                      type: "error",
                    })
                    return;
                  }

                  updateObj({
                    ...obj,
                    startDate: e.target.value
                  })
                }}
              />
            </div>

            <div className="col-md-6 col-lg-6 input-wrapper">
              <div className="label-text" style={{ fontWeight: 600, fontSize: "15px" }}>
                Start Time
              </div>
              <InputField
                className="col-md-8 time-picker"
                placeholder="Start time"
                type="time"
                value={obj?.startTime}
                handleChange={(e) => {
                  updateObj({
                    ...obj,
                    startTime: e.target.value
                  })
                }}
              />
            </div>

          </div>
          {/* end time */}
          <div className="d-flex mt-2">

            <div className="col-md-6 col-lg-6 input-wrapper">
              <div className="label-text" style={{ fontWeight: 600, fontSize: "15px" }}>
                End Date
              </div>
              <InputField
                className="col-md-8 time-picker"
                placeholder="End Date"
                value={obj?.endDate}
                calendar={true}
                handleChange={(e) => {
                  const selectedDate = e.target.value;
                  if (isDateBeforeToday(e.target?.value)) {
                    displayToast({
                      text: "Selected date cannot be before today",
                      type: "error",
                    })
                    return;
                  }
                  if (obj?.startDate && isDateBeforeFrom(obj.startDate, selectedDate)) {
                    displayToast({
                      text: "To date cannot be smaller than From date",
                      type: "error",
                    });
                    return;
                  }
                  updateObj({
                    ...obj,
                    endDate: e.target.value
                  })
                }}
              />
            </div>

            <div className="col-md-6 col-lg-6 input-wrapper">
              <div className="label-text" style={{ fontWeight: 600, fontSize: "15px" }}>
                End Time
              </div>
              <InputField
                className="col-md-8 time-picker"
                placeholder="End Time"
                value={obj?.endTime}
                type="time"
                handleChange={(e) => {
                  console.log("da", e.target.value)
                  updateObj({
                    ...obj,
                    endTime: e.target.value
                  })
                }}
              />
            </div>

          </div>
          <div className="mt-2">
            <div className="label-text" style={{ fontWeight: 600, fontSize: "15px" }}>
              Reasons
            </div>
            <InputField
              className="col-md-8 time-picker"
              placeholder="Reasons"
              value={obj?.reason}
              type="text"
              handleChange={(e) => {
                console.log("da", e.target.value)
                updateObj({
                  ...obj,
                  reason: e.target.value
                })
              }}
            />
          </div>
        </Modal.Body>
        <div style={{ display: 'flex', columnGap: '10px', padding: '10px' }}>
          <Button
            text="Block Calendar"
            onClick={() => {
              if (
                (!obj?.startDate && !obj?.startTime) ||
                (!obj?.startDate && obj?.startTime) ||
                (obj?.startDate && !obj?.startTime) ||
                (!obj?.endDate && !obj?.endTime) ||
                (!obj?.endDate && obj?.endTime) ||
                (obj?.endDate && !obj?.endTime)
              ) {
                displayToast({
                  text: "Please select 'From Date', 'From Time', 'To Date', and 'To Time' to set the unavailability",
                  type: "error",
                });
              } else {
                handleClick();
              }
            }}
            id="block-calendar"
          />

          <Button
            text="Absence List"
            //type="submit"
            onClick={() =>
              history.push({
                pathname: "/editStaffUnavailability",
                state: { idValue: userDetail?.id },
                // state: { idValue: "e84acec3-a5ac-485b-b860-98ccf154242d" },
              })
            }
            id="save"
          />
        </div>

      </Modal>

    </div >
  )
}



